import { useEffect, useState } from "react";
import { exportCompleteSpreadsheet } from "../../services/spreadsheetExport";

export default function useExportActions({
  tournaments,
  registros,
  displayCurrency,
}) {
  const [exportStatus, setExportStatus] = useState(null);
  const [sideMenuOpen, setSideMenuOpen] = useState(false);
  const [activeExportAction, setActiveExportAction] = useState(null);

  useEffect(() => {
    if (!exportStatus) return undefined;
    const timeout = window.setTimeout(() => setExportStatus(null), 3000);
    return () => window.clearTimeout(timeout);
  }, [exportStatus]);

  const showExportStatus = (type, message) => {
    setExportStatus({ type, message });
  };

  const closeSideMenu = () => {
    setSideMenuOpen(false);
    setActiveExportAction(null);
  };

  const handleExportSpreadsheet = () => {
    try {
      exportCompleteSpreadsheet(registros, tournaments, { displayCurrency });
      showExportStatus("success", "Planilha exportada com sucesso.");
      closeSideMenu();
    } catch (error) {
      showExportStatus("error", error.message || "Nao foi possivel exportar a planilha.");
    }
  };

  return {
    exportStatus,
    sideMenuOpen,
    setSideMenuOpen,
    activeExportAction,
    setActiveExportAction,
    closeSideMenu,
    handleExportSpreadsheet,
  };
}
